export const CHART_BAR_ORIENTATION = {
	HORIZONTAL: 'horizontal',
	VERTICAL: 'vertical',
};

export const CHART_BAR_ORIENTATION_OPTIONS = [
	{ value: CHART_BAR_ORIENTATION.VERTICAL, label: '纵向' },
	{ value: CHART_BAR_ORIENTATION.HORIZONTAL, label: '横向' },
];

export const normalizeChartBarOrientation = (value, defaultOrientation = CHART_BAR_ORIENTATION.VERTICAL) => {
	if (value === CHART_BAR_ORIENTATION.HORIZONTAL) return CHART_BAR_ORIENTATION.HORIZONTAL;
	if (value === CHART_BAR_ORIENTATION.VERTICAL) return CHART_BAR_ORIENTATION.VERTICAL;
	return defaultOrientation;
};

export const isHorizontalBarOrientation = (orientation) => orientation === CHART_BAR_ORIENTATION.HORIZONTAL;

export const resolveBarBorderRadius = (horizontal) => (horizontal ? [0, 4, 4, 0] : [4, 4, 0, 0]);

export const resolveBarLabelPosition = (horizontal) => (horizontal ? 'right' : 'top');

export const getChartBarOrientationLabel = (orientation) =>
	CHART_BAR_ORIENTATION_OPTIONS.find((item) => item.value === orientation)?.label ?? '纵向';
